import { Component } from '@angular/core';

@Component({
  selector: 'ngx-shoppinglists',
  templateUrl: './shoppinglists.component.html',
  styleUrls: ['./shoppinglists.component.scss']
})
export class ShoppinglistsComponent {

}
